import { useMatch, useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_ROADWORK, APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADWORKS } from "../../../../common/constants/modules"
import { RoadworkSectionAdapter } from "../../containers/RoadworkSectionAdapter"
import { RoadworkSectionSidebar } from "../../containers/RoadworkSectionSidebar"
import { RoadworksRoadSidebar } from "../../containers/RoadworksRoadSidebar"
import { RoadworksSidebar } from "../../containers/RoadworksSidebar"

import { RoadworkValidator } from "../RoadworkValidator/RoadworkValidator"

export const RoadworksMobileRoutes = () => {

    const match = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADWORKS}/:road/:roadworkUuid`)
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadworksMobileRoutes = useRoutes([
        {
            path: "/",
            element:
                <>
                    <MapAdapterBoundingBox module={API_MODULE_ROADWORK} />
                    <SegmentSelectListener />
                    <RoadworksSidebar />
                </>,
        },
        {
            path: "/:road",
            element:
                <>
                    <RoadworksRoadSidebar />
                    <DetailSegmentSelectListener />
                    <MapAdapterRoad module={API_MODULE_ROADWORK} />
                </>,
        },
        {
            path: "/:road/:roadworkUuid/*",
            element: <RoadworkValidator>
                <RoadworkSectionAdapter roadworkUuid={match?.params?.roadworkUuid} />
                <RoadworkSectionSidebar />
            </RoadworkValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return roadworksMobileRoutes
}